import React, { useState } from 'react'
import { FacilityBreakdownCalendarComponent } from './CalendarEvents/FacilityBreakdownCalendarComponent'
import { FacilityBreakdownQuestionnaireComponent } from './QuestionnaireForms/FacilityBreakdownQuestionnaireComponent'
import { ToDoListMainContainer } from './ToDoList/FacilityBreakdownToDoComponent'
import { FacilityBreakdownWorkFlowComponent } from './Workflows/FacilityBreakdownWorkFlowComponent'


export default function FacilityBreakdownComponent({ res }) {
    const [tab, setTab] = useState('Facility Details')
    return (<div className='text-start'>
        <div className='d-flex position-fixed shadow p-1 rounded'>
            <button onClick={e => setTab('Facility Details')} className={`btn ${tab === 'Facility Details' && 'active'}`}>Facility Details</button>
            <button onClick={e => setTab('Questionnaires / Forms')} className={`btn ${tab === 'Questionnaires / Forms' && 'active'}`}>Questionnaires / Forms</button>
            <button onClick={e => setTab('Calendar Events')} className={`btn ${tab === 'Calendar Events' && 'active'}`}>Calendar Events</button>
            <button onClick={e => setTab('Todo list')} className={`btn ${tab === 'Todo list' && 'active'}`}>Todo list</button>
            <button onClick={e => setTab('Workflows')} className={`btn ${tab === 'Workflows' && 'active'}`}>Workflows</button>
        </div>
        <div className='pt-5' style={{ overflow: 'auto' }}>
            {
                {
                    'Facility Details':
                        <div>
                            <b>Facility</b> {res.facility.facility}
                        </div>,
                    'Questionnaires / Forms':
                        <div>
                            {res.questionnaires && res.questionnaires.map(r => <FacilityBreakdownQuestionnaireComponent questionnaire={r} />)}
                        </div>,
                    'Todo list':
                        <div>
                            <ToDoListMainContainer res={res} />
                        </div>,
                    'Calendar Events':
                        <div>
                            {res.calendars && res.calendars.map(r => <FacilityBreakdownCalendarComponent calendar={r} />)}
                        </div>,
                    'Workflows': <div>
                        <pre>
                            {res.workFlows && res.workFlows.map(r => <FacilityBreakdownWorkFlowComponent workflow={r} />)}
                        </pre>
                    </div>
                }[tab]
            }
        </div>
    </div>)
}
